// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import { Pagable } from '@/constants/pagable';
import { Pagable } from 'src/constants/pagable';
import { CustomPagable } from 'src/constants/custom-pagable';

type Pagable_ = {
  page: number;
  size: number;
  sort: string;
};

// function useQuery() {
//   // const { search } = useLocation();

//   return React.useMemo(() => new URLSearchParams(search), [
//     search,
//   ]);
// }
export class RequestUtils {
  // static query = useQuery();

  static getParamFromQuery(field: string): string {
    return '';
    // return this.query.get(field) as string;
  }

  static merge(object1: any, object2: any): any {
    const object3: any = {};
    object1 &&
      Object.keys(object1).forEach(
        key => (object3[key] = object1[key]),
      );
    object2 &&
      Object.keys(object2).forEach(
        key => (object3[key] = object2[key]),
      );
    return object3;
  }

  static initPageableParams(pagable: CustomPagable): Pagable_ { // change Pagable to CustomPagable to fix lost pagination error
    const order =
      pagable.order === 'ascending' ||
      pagable.order === 'asc'
        ? 'asc'
        : pagable.order === 'descending' ||
          pagable.order === 'desc'
        ? 'desc'
        : '';
    return {
      page: pagable.page || 0,
      size: pagable.size || 1000,
      sort: pagable.sort
        ? `${pagable.sort}${order ? ',' + order : ''}`
        : '',
    };
  }

  serialize(obj: any) {
    const str: string[] = [];
    for (const p in obj) {
      if (
        Object.prototype.hasOwnProperty.call(obj, p) &&
        obj[p] != null
      ) {
        if (obj[p] !== undefined) {
          str.push(
            encodeURIComponent(p) +
              '=' +
              encodeURIComponent(obj[p]),
          );
        }
      }
    }
    return str.join('&');
  }
}

export const requestUtils = new RequestUtils();
